import { AccountType } from 'constants/AccountType';

export enum LoginType {
  Email = 'EMAIL',
  Sms = 'SMS',
}
export interface IAuthBodyRequest {
  username: string;
  password: string;
  type: AccountType | null;
  loginType: LoginType;
}

export interface IAuthResponse {
  accessToken?: string;
  refreshToken?: string;
  phoneNumber?: string;
}

export interface IVerifyAuthCodeBodyRequest {
  username: string;
  password: string;
  type: AccountType | null;
  code: string;
}

export interface IDecodedAccessToken {
  jti: string;
  sub: string;
  iat: number;
  exp: number;
  'First name'?: string;
  'Last name'?: string;
}

export interface IForgotPasswordRecaptcha {
  success: boolean;
  challenge_ts: string | null;
  hostname: string | null;
  score: number;
  action: string | null;
  'error-codes': Array<string | null>;
}

export interface ILoginForm {
  email: string;
  password: string;
  type: AccountType | null;
  loginType?: LoginType;
}

export interface IRefreshAuthTokenRequest {
  refreshToken: string;
}

export interface IRefreshAuthTokenResponse {
  accessToken: string;
  refreshToken: string;
}

export interface ILoginBanInfo {
  minutes: number;
  attempts: number;
}

export interface IValidateResetPasswordLinkRequest {
  token: string;
}

export interface ISetPasswordBodyRequest {
  oldPassword: string;
  newPassword: string;
  accessToken: string | null;
}
